<template>
  <div ref="swiperRef" class="swiper-container">
    <div class="swiper-wrapper">
      <div
        v-for="(item, index) of content.bannerList"
        :key="item.imagUrl || item.url"
        class="swiper-slide"
        :class="{
          prev: activeIndex - 1 === index,
          active: activeIndex === index,
          next: activeIndex + 1 === index,
        }"
      >
        <img class="banner" :src="item.imagUrl || item.url" alt="" @click="handleJump(item)" />
      </div>
    </div>
    <div v-if="content.bannerList.length > 1" class="inner-wrap">
      <div v-for="(item, index) in content.bannerList.length" :key="item" class="inner" :class="{ active: activeIndex === index }" />
    </div>

    <van-popup v-model="show">{{ showText }}</van-popup>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Popup } from 'vant'

export default {
  name: 'Banner',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      activeIndex: 0,
      show: false,
      showText: '',
    }
  },
  mounted() {
    let swiper = new Swiper(this.$refs.swiperRef, {
      autoplay:
        this.$props.content.bannerList.length > 1
          ? {
              delay: this.$props.content.bannerTime,
              disableOnInteraction: false,
              allowTouchMove: true,
            }
          : false,
      on: {
        slideChange: () => {
          this.activeIndex = swiper.activeIndex
        },
      },
    })
  },
  methods: {
    /** 处理跳转 */
    handleJump(item) {
      this.showText = item.appletLink || item.wxLink
      this.show = true
    },
  },
}
</script>

<style scoped lang="less">
.swiper-container {
  position: relative;
  width: 100%;
  height: 200px;

  /deep/ .van-popup {
    background: transparent;
    color: #fff;
  }

  .swiper-wrapper {
    display: flex;
  }

  .inner-wrap {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;

    .inner {
      width: 8px;
      height: 8px;
      background: #fff;
      border-radius: 50%;
      margin-right: 6px;

      &.active {
        width: 20px;
        background: #f93809;
        border-radius: 4px;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .swiper-slide {
    width: 750px;
    height: 200px;
    padding: 0 32px;
    flex-shrink: 0;

    .banner {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }

    .icon {
      width: 686px;
      height: 200px;
    }

    &.card {
      transition: all 0.3s;

      &.prev {
        padding-right: 0;
        padding-left: 116px;
        transform: scale(0.91) translateX(32px);
        transform-origin: right;
      }
      &.active {
        padding: 0 58px;
      }
      &.next {
        padding-left: 0;
        padding-right: 116px;
        transform: scale(0.91) translateX(-34px);
        transform-origin: left;
      }
    }
  }
}
</style>
